module.exports = __webpack_public_path__ + "static/media/warning.0f64d362.svg";